import React, { Component } from 'react';

class Input extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: '',
      show: false
    };
  }

  componentDidMount() {}
  componentDidUpdate() {}
  shouldComponentMount(nextProps, nextState) {}
  handleChange = e => {
    this.setState({ value: e.target.value, show: false });
  };

  keyPress = e => {
    const patt = /^[a-zA-Zñ0-9 ]+$/;
    let result = patt.test(e.target.value);
    if (e.keyCode === 13) {
      if (result) {
        this.props.handleDataList(e.target.value);
        this.setState({ value: '', show: false });
      } else {
        this.setState({ show: true });
      }
    } else if (e.keyCode === 27) {
      this.setState({ value: '', show: false });
      this.props.onEscape(e);
    }
  };

  hadleBlur = e => {
    //this.setState({ value: '' });
  };

  delete = e => {
    this.props.handleDelete(e.target.dataset.value);
  };

  // get the list element id to add item on it
  handleGetListId = e => {
    e.stopPropagation();
    let id = document.getElementById('li-background');
    if (id) {
      document.getElementById('li-background').removeAttribute('id');
    }
    if (e.target.tagName === 'SPAN') {
      e.target.parentElement.id = 'li-background';
    } else {
      e.target.id = 'li-background';
    }

    this.props.handleGetListId({
      listId: e.target.dataset.id,
      listName: e.target.dataset.name
    });
  };

  render() {
    const { data, listId, language, lists, isCrerate, disableListHover } = this.props;
    let result = '';
    if (lists) {
      result = lists.datos.map((item, i) => {
        return (
          <li
            key={i}
            data-id={item.id}
            data-name={item.name}
            onClick={!disableListHover ? this.handleGetListId : null}
          >
            {item.name}
            {disableListHover ? (
              ''
            ) : (
              <div className="tooltip-wraper">
                <span className="icon-delete">
                  <i
                    className="fas fa-times-circle"
                    onClick={this.props.handleShowModal}
                    data-value={item.id}
                    data-namealert={item.name}
                  />
                </span>
                <div className="toolti">
                  <span className="tooltptext">{language.card.list.delete}</span>
                </div>
              </div>
            )}
            <span
              data-id={item.id}
              data-name={item.name}
              className="list-pop-up"
              onClick={this.handleGetListId}
            >
              {language.card.input.addItemLabel}
            </span>
          </li>
        );
      });
    }

    return (
      <div
        className="input-container"
        ref={el => {
          this.el = el;
        }}
      >
        <ul>
          <li>
            <ul className={`item-list ${disableListHover ? '' : 'list-hvover'}`}>{result}</ul>
          </li>

          {isCrerate && disableListHover == false ? (
            <li className="uper-input-label">
              <input
                type="text"
                className={`${this.state.show ? 'input-out-line' : ''}`}
                id="fname"
                name="lista"
                placeholder={this.props.language.card.list.placeholder}
                value={this.state.value}
                onChange={this.handleChange}
                onKeyDown={this.keyPress}
                onBlur={this.hadleBlur}
                autoComplete="off"
                autoFocus
              />
              <ul>
                <li className="popup-container">
                  <div className={`popup ${this.state.show ? 'show' : ''}`}>
                    <span className="popuptext" id="myPopup">
                      {language.card.input.labelAlert}
                    </span>
                  </div>
                </li>
              </ul>
            </li>
          ) : (
            ''
          )}

          {isCrerate && disableListHover == false ? (
            <li className="under-input-label">{this.props.language.card.list.label}</li>
          ) : (
            ''
          )}
        </ul>
      </div>
    );
  }
}
export default Input;



// WEBPACK FOOTER //
// ./source/client/components/dynamic_list/Input.jsx